var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"7","viewBox":"0 0 11 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 1.5L5.5 5.5L1 1.5","stroke":_vm.color,"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }